import { useContext } from 'react';
import MerchantContext from '../context/merchantContext';

/**
 * useMerchantContext is a convenience hook to access the merchant context
 */
export default function useMerchantContext() {
  return useContext(MerchantContext);
}
